import { Alert, AlertIcon, AlertTitle, Box } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export function MainnetOnlyNotice() {
  const { t } = useTranslation()

  return (
    <Box w="full" py={{ base: 8, md: 12 }}>
      <Alert
        status="info"
        borderRadius="lg"
        maxW="container.md"
        mx="auto"
        px={{ base: 4, md: 6 }}
        py={{ base: 3, md: 4 }}
      >
        <AlertIcon />
        <AlertTitle fontSize={{ base: 'sm', md: 'md' }}>
          {t('featureMainnetOnly')}
        </AlertTitle>
      </Alert>
    </Box>
  )
}
